import { createContext, useContext } from 'react';

export type FileTreeDropContextValue = {
  enabled: boolean;
  onInternalDrop: (fileId: string, fromFolderId: string | null, toFolderId: string | null) => void;
  onOsDrop: (folderId: string, files: File[]) => void;
};

export const FileTreeDropContext = createContext<FileTreeDropContextValue | null>(null);

export function useFileTreeDrop() {
  return useContext(FileTreeDropContext);
}
